import { type ComputedRef, computed } from 'vue';

import moduleBreakpoints from '@/app/styles/sass/breakpoints.module.scss';
import type { Size } from '@mkskom/ui';
import { useBreakpoints } from '@vueuse/core';

const convertedBreakpoints = Object.fromEntries(
  Object.entries(moduleBreakpoints).map(([key, value]) => [
    key,
    parseInt(value, 10),
  ])
);

const defaultBreakpoint = convertedBreakpoints['breakpointM'];

const breakpointsValues = {
  s: convertedBreakpoints['breakpointS'],
  m: defaultBreakpoint,
  l: convertedBreakpoints['breakpointL'],
};

const breakpoints = useBreakpoints(breakpointsValues, {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  ssrWidth: defaultBreakpoint,
});

export const useAdaptive = () => {
  const activeBreakpoint = (breakpoints.active() ?? 'm') as ComputedRef<Size>;
  const isSmallScreen = breakpoints.smallerOrEqual('s');
  const isMiddleScreen = breakpoints.between('m', 'l');
  const isLargeScreen = breakpoints.greaterOrEqual('l');

  const getActiveBreakpoint = computed(() => activeBreakpoint.value);
  const getActiveBreakpointValue = computed(
    () => breakpointsValues[getActiveBreakpoint.value]
  );

  return {
    isSmallScreen,
    isMiddleScreen,
    isLargeScreen,
    activeBreakpoint: getActiveBreakpoint,
    activeBreakpointValue: getActiveBreakpointValue,
  };
};
